import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo, useCallback } from "react";
import { BillLineItem } from "@common/types/bill";
import { useUpdateBillLineItem } from "@api/bill.api";
import {
    AccrualAccountCell,
    UpdateLineItemAccountParams,
} from "@components/lineItems/AccrualAccountCell";
import { LineItemFallbackAccountType } from "@common/helpers/accounting";
import {
    getLedgerIdFromColumnId,
    getLedgerNameFromColumnId,
} from "@lib/ledgerViewColumns";

export const AccountsPayableCell = memo(
    ({
        row,
        column,
    }: CellContext<ViewTableFeatures, BillLineItem, unknown>) => {
        const updateBillLineItem = useUpdateBillLineItem();
        const lineItem = row.original;
        const ledgerId = getLedgerIdFromColumnId(column.id);
        const ledgerName = getLedgerNameFromColumnId(column.id);

        const onUpdateLineItemAccount = useCallback(
            ({
                workspaceId,
                lineItemId,
                accountOverrides,
            }: UpdateLineItemAccountParams) =>
                updateBillLineItem.mutateAsync({
                    workspaceId,
                    lineItemId,
                    accountsPayableOverrides: accountOverrides,
                }),
            [updateBillLineItem],
        );

        return (
            <AccrualAccountCell
                lineItemId={lineItem.id}
                lineItemAccountId={lineItem.accountsPayableId}
                accountOverrides={lineItem.accountsPayableOverrides}
                ledgerId={ledgerId}
                ledgerName={ledgerName}
                fallbackMode={LineItemFallbackAccountType.billAccountsPayable}
                entityId={lineItem.bill?.entityId}
                onUpdateLineItemAccount={onUpdateLineItemAccount}
            />
        );
    },
);
